import * as yup from "yup";

export const officerSchema = (officerType = null) =>
  yup.object().shape({
    name: yup.string().required("Officer name is required."),

    badgeNumber: yup.string().required("Officer badge number is required."),

    stationName:
      !officerType || officerType === 1
        ? yup.string().required("Station name is required.")
        : yup.string().notRequired(),

    phoneNumber: yup.string().required("Station contact number is required."),

    address1: yup.string().notRequired(),

    address2: yup.string().notRequired(),

    town: yup.string().notRequired(),

    postcode: yup.string().notRequired(),
  });
